import React, { useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";

// Ensure moment.js is properly initialized
moment.suppressDeprecationWarnings = true;
const localizer = momentLocalizer(moment);

// Default sample events
const defaultEvents = [
  {
    id: 1,
    title: "Meeting with Team",
    start: new Date(2025, 2, 10, 10, 0), // March 10, 2025, 10:00 AM
    end: new Date(2025, 2, 10, 11, 0), // March 10, 2025, 11:00 AM
  },
  {
    id: 2,
    title: "Lunch with Client",
    start: new Date(2025, 2, 12, 13, 0), // March 12, 2025, 1:00 PM
    end: new Date(2025, 2, 12, 14, 0), // March 12, 2025, 2:00 PM
  },
];

const MyCalendar = ({
  initialEvents = defaultEvents,
  hiddenHours = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23],
  height = "1000px",
  minDate = new Date(2025, 2, 10, 0, 0),
  maxDate = new Date(2025, 2, 10, 23, 59),
  customEventStyler,
  onEventAdded,
}) => {
  const [events, setEvents] = useState(initialEvents);

  const handleSelect = ({ start, end }) => {
    const title = window.prompt("Enter event title:");
    if (title) {
      const newEvent = {
        id: events.length + 1,
        title,
        start,
        end,
      };

      const updatedEvents = [...events, newEvent];
      setEvents(updatedEvents);

      // Optional callback for external event handling
      if (onEventAdded) {
        onEventAdded(newEvent);
      }
    }
  };

  const defaultEventStyleGetter = (event, start, end, isSelected) => {
    return {
      style: {
        backgroundColor: event.title.includes("Meeting")
          ? "#3174ad"
          : "#ff9800",
        borderRadius: "5px",
        opacity: 0.8,
        color: "white",
        border: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "0.8rem",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        padding: "2px 5px",
        height: "20px",
      },
    };
  };

  const eventStyleGetter = customEventStyler || defaultEventStyleGetter;

  return (
    <div style={{ height, padding: "10px" }}>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        selectable
        onSelectSlot={handleSelect}
        defaultView="month"
        views={{
          month: true,
          week: true,
          work_week: true,
          day: true,
          agenda: true,
        }}
        eventPropGetter={eventStyleGetter}
        step={60}
        timeslots={2}
        min={minDate}
        max={maxDate}
        formats={{
          timeGutterFormat: (date, culture, localizer) =>
            hiddenHours.includes(moment(date).hour())
              ? ""
              : localizer.format(date, "h:mm A", culture),
        }}
        style={{ height }}
      />
    </div>
  );
};

export default MyCalendar;
